import { logoutHandler } from "@/auth/logout";
import { envVars } from "@/envVars";
import axios from "axios";
import Cookies from "js-cookie";

export async function refreshToken() {
  const refreshToken: string | null =
    typeof window !== "undefined" ? Cookies.get("refresh-token") ?? null : null;

  if (!refreshToken) return;
  try {
    const response = await axios.post(
      `${envVars.API_BASE_URL}/auth/refresh-token`,
      {},
      {
        headers: {
          Refresh: `Bearer ${refreshToken}`,
        },
      }
    );
    if (response.status === 201) {
      Cookies.set("token", response.data.token);
      Cookies.set("refresh-token", response.data.refreshToken);
    } else if (response.status === 401) {
      logoutHandler();
    }
  } catch (e) {
    console.log(e);
  }
}
